<div [ngStyle]="style()" class="mockup-code w-full bg-black">
	@if(maxLoad()){
		<progress class="progress" [value]="valLoad()" [max]="maxLoad()"></progress>
	}
	@for(log of logs().logs; track log){
		<pre [attr.data-prefix]="log.pre" [ngClass]="getClasses(log)"><code>{{log.text}}</code></pre>
	}
	@if(loading()){
		<progress class="progress"></progress>
	}
</div>